// extracted by mini-css-extract-plugin
export var fadeInOut = "_15-3";
export var icon = "_15-4";
export var savedIndicator = "_15-2";
export var savingIndicator = "_15-0";
export var spin = "_15-1";